import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'DownloadIcon',
  'download',
  'M272.532 492.876c-22.043 20.618-22.043 54.045 0 74.663s57.78 20.617 79.822 0l106.039-99.184v285.251c0 29.158 25.271 52.795 56.443 52.795s56.443-23.637 56.443-52.795v-279.945l100.367 93.878c22.042 20.617 57.779 20.617 79.821 0s22.042-54.045 0-74.663l-192.906-180.433c-25.713-24.059-67.408-24.059-93.125 0l-192.905 180.433zM204.8 345.6v-51.2c0-56.556 45.846-102.4 102.4-102.4h409.6c56.556 0 102.4 45.844 102.4 102.4v51.2c0 28.278 22.922 51.2 51.2 51.2s51.2-22.922 51.2-51.2v-51.2c0-113.106-91.694-204.8-204.8-204.8h-409.6c-113.108 0-204.8 91.694-204.8 204.8v51.2c0 28.278 22.923 51.2 51.2 51.2s51.2-22.922 51.2-51.2z',
)
